import React from 'react';
import { Card } from '@/components/shared/card';

interface InsightsDisplayProps {
  responses: Record<string, string>;
}

const InsightsDisplay = ({ responses }: InsightsDisplayProps) => {
  const calculateReadinessScore = (responses: Record<string, string>) => {
    const totalResponses = Object.keys(responses).length;
    const completedResponses = Object.values(responses).filter(value => value && value.trim() !== '').length;
    return Math.round((completedResponses / totalResponses) * 100);
  };

  const score = calculateReadinessScore(responses);

  return (
    <Card className="p-6 mt-4">
      <h4 className="text-lg font-semibold mb-4">Readiness Assessment Summary</h4>
      
      <div className="space-y-4">
        <div>
          <h5 className="font-medium text-blue-600 mb-2">Completion Score</h5>
          <p className="text-2xl font-bold">{score}%</p>
          <p className="text-sm text-gray-600 mt-1">
            Based on the number of questions answered in this assessment.
          </p>
        </div>

        <div className="mt-4">
          <h5 className="font-medium text-green-600 mb-2">Next Steps</h5>
          <ul className="list-disc pl-5 space-y-1">
            <li>Review any unanswered questions in your assessment</li>
            <li>Share this assessment with your team for feedback</li>
            <li>Use these insights to plan your AI implementation strategy</li>
          </ul>
        </div>
      </div>
    </Card>
  );
};

export default InsightsDisplay;